// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"819cea8f","659":"857514c8"}[chunkId] + ".chunk.css";
};